const credentials = {
 //dev
   apiUrl: 'https://devtourapi.concept3d.com/api/admin',
   tourApiUrl: 'https://devtourapi.concept3d.com/api',
   redirectUri: 'http://devaccounts.concept3d.com/callback',
   accountsAPI: 'https://devaccountsapi.concept3d.com/api',
   transitAPI: 'https://devtransitbackend.concept3d.com', 
   cmsURL: 'https://devcms.concept3d.com',
};
export default credentials;